export type CommunicationThreadScope = 'customer' | 'record';
